import { Pipe, PipeTransform } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from '../../../../core/core.state'
import { productSelectors } from '../../../product/product.selectors'
import { SaleItem } from '../sale-item'
import { Observable } from 'rxjs'
import { SaleItemPriceDetails, SaleItemService } from '../sale-item.service'

@Pipe({
  name: 'getSaleItemProductPrice'
})
export class GetSaleItemProductPricePipe implements PipeTransform {
  productEntities$ = this.store.select(productSelectors.selectEntities)

  constructor(
    private store: Store<AppState>,
    private saleItemService: SaleItemService
  ) {}

  transform(saleItem: SaleItem): Observable<SaleItemPriceDetails> {
    return this.saleItemService.getSaleItemProductPriceDetails$(saleItem)
  }
}
